// extracted by mini-css-extract-plugin
export default {"container":"SmallLoader_container__6zkYU","spinner":"SmallLoader_spinner__cF2wK","spinner-d3o0rx":"SmallLoader_spinner-d3o0rx__4dy6y"};